import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { StoreUtil } from "../utils";

const state = {
    loginInfo: StoreUtil.state(),
    registerInfo: StoreUtil.state(),
    userInfo: StoreUtil.state(),
    //backend#57: Adresse, deren Konto noch nicht bestaetigt ist (nach einer Anmeldung mit 403)
    emailUnbestaetigt: null,
}

const loginModule = {
    state,
    mutations,
    actions,
    getters
}

export default loginModule;